import React, { useState } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Input, Button, message, Select, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { cloudFunctions, db } from '../../config/Fire';
import * as Constants from './../../constants/nodes_database';

const { Option } = Select;

const userFilters = {
    "": "Ninguno",
    "nameOrEmail": "Nombre ó Correo electrónico",
}

const conditionFilters = {
    "": "Ninguno",
    "next": "Próximamente",
}

const FormSendPushsToUsers = () => {

    const [form] = Form.useForm();
    const [isSending, setIsSending] = useState(false);
    const [filterSelected, setFilterSelected] = useState("");
    const [selectedUsersKeys, setSelectedUsersKeys] = useState([]);
    const [users, setUsers] = useState(null);

    const handleSubmit = values => {
        const data = {
            title: values.title,
            body: values.body,
        }
        submit(data);
    };

    const submit = data => {
        setIsSending(true)
        cloudFunctions.sendPushToUsers({
            title: data.title,
            body: data.body,
            filterSelected: filterSelected ? filterSelected : "",
            filterArray: selectedUsersKeys,
        })
        .then(response => {
            if(response.data.code === 0) {
                message.success('El mensaje se envió exitosamente.');
                handleReset();
            } else {
                message.error('Se produjo un error. Por favor, revise los campos.');
                setIsSending(false)
            }
        })
        .catch(err => {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo más tarde.');
            console.log(err);
            setIsSending(false)
        });
    };

    const handleReset = () => {
        setIsSending(false)
        setFilterSelected("")
        setSelectedUsersKeys([])
        form.resetFields();
    };

    const onUserFilterSelected = (value) => {
        if(value !== "" && users === null) {
            return db.ref(`${Constants.USERS}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var usersMap = snapshot.val();
                    setFilterSelected(value)
                    setUsers(usersMap)
                    setSelectedUsersKeys([])
                } else {
                    console.log("get users not found: " + null);
                }
            })
            .catch(err => {
                console.log("get users not found: " + err);
            });
        } else {
            setFilterSelected(value)
        }
    }
    
    const handleSearch = (inputValue, option) => {
        var key = option.props.value
        var valueLowerCase = inputValue.toLowerCase();
        if(inputValue.length >= 1) {
            var userName = users[key].firstName.toLowerCase();
            var userEmail = users[key].email.toLowerCase();
            if(userName.includes(valueLowerCase) || userEmail.includes(valueLowerCase)) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }
    };
    
    const handleChange = selectedItems => {
        setSelectedUsersKeys(selectedItems)
    };

    
    return (
        <Grid className="gridCont">
            <Form onFinish={handleSubmit} form={form}>
                <Row center="xs">
                    <Col xs={12}>
                        <Form.Item name="title" rules={[{ required: true, message: 'Por favor, ingresa el título del mensaje', },]}>
                            <Input placeholder="Título" suffix={<Tooltip title="Para insertar dentro del título las variables correspondientes al usuario, coloque --nombres--, --apellidos--, --email-- o --telefono--"><QuestionCircleOutlined /></Tooltip>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12}>
                        <Form.Item name="body" rules={[{ required: true, message: 'Por favor, ingresa el contenido del mensaje', },]}>
                            <Input placeholder="Mensaje" suffix={<Tooltip title="Para insertar dentro del contenido las variables correspondientes al usuario, coloque --nombres--, --apellidos--, --email-- o --telefono--"><QuestionCircleOutlined /></Tooltip>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} md={4}>
                        <Form.Item name="user_type_filter">
                            <Select placeholder="Filtro de usuarios" onSelect={onUserFilterSelected}>
                                {
                                    userFilters && Object.keys(userFilters).map(key => <Option key={key} value={key}>{userFilters[key]}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={8}>
                    {
                        filterSelected !== "" ?
                                <Form.Item>
                                    {
                                        <Select
                                            mode="multiple"
                                            onChange={handleChange}
                                            optionLabelProp="label"
                                            filterOption={handleSearch}
                                            placeholder="Escriba el nombre ó correo del usuario"
                                            style={{ width: '100%' }}>
                                            {
                                                users && Object.keys(users).map(key => {
                                                    return (
                                                        <Option key={key} value={key} label={`${users[key].firstName} / ${users[key].email}`}>{`${users[key].firstName} / ${users[key].email}`}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    }
                                </Form.Item>
                            :
                            null
                    }
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} md={6}>
                        <Form.Item name="condition_filter">
                            <Select placeholder="Condicion de filtrado">
                                {
                                    conditionFilters && Object.keys(conditionFilters).map(key => <Option key={key} value={key} disabled>{conditionFilters[key]}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Row center="xs">
                        <Col xs={6} sm={6} md={6}>
                        {
                            isSending ?
                                <Button type="primary" htmlType="submit" disabled={true} loading>
                                    Enviar
                                </Button>
                                :
                                <Button type="primary" htmlType="submit" disabled={false}>
                                    Enviar
                                </Button>
                        }
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                            <Button onClick={handleReset}>
                                Limpiar campos
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </Grid>
    );
}

FormSendPushsToUsers.propTypes = {
};

export default FormSendPushsToUsers;